import axiosInstance from '../axiosInstance';


class AppointmentService {
  /**
   * Book an appointment
   * @param {Object} appointmentData - Appointment booking data
   * @returns {Promise<Object>} Booking response data
   */
  static async bookAppointment(appointmentData) {
    const {
      appt_date,
      appt_time,
      clinic_id,
      clinic_name,
      location,
      notes,
      patient,
      type,
      amount,
      appt_type,
      appt_mode,
      appt_url
    } = appointmentData;

    // Validate required fields
    if (!appt_date || !appt_time || !clinic_id || !patient) {
      throw new Error('Appointment date, time, clinic ID, and patient are required');
    }

    try {
      const queryParams = new URLSearchParams({
        appt_date: appt_date.toString(),
        appt_time: appt_time.toString(),
        clinic_id: clinic_id.toString(),
        clinic_name: clinic_name || '',
        location: location || '',
        notes: notes || '',
        patient: patient.toString(),
        type: type || '',
        amount: amount || '',
        appt_type: appt_type || '',
        appt_mode: appt_mode || '',
        appt_url: appt_url || ''
      }).toString();

      const { data } = await axiosInstance.post(`/visits/appointments?${queryParams}`);
      return data;
    } catch (error) {
      console.error('Book appointment error:', error);
      throw error;
    }
  }

  /**
   * Get appointments for a patient
   * @param {string|number} patientId - Patient ID
   * @returns {Promise<Object>} Appointments data
   */
  static async getAppointments(patientId) {
    if (!patientId) {
      throw new Error('Patient ID is required');
    }

    try {
      const { data } = await axiosInstance.get(`/visits/appointments?patient_id=${patientId}`);
      return data;
    } catch (error) {
      console.error('Get appointments error:', error);
      throw error;
    }
  }

  /**
   * Get list of doctors
   * @returns {Promise<Object>} Doctors data
   */
  static async getDoctors() {
    try {
      const { data } = await axiosInstance.get('/visits/doctors');
      return data;
    } catch (error) {
      console.error('Get doctors error:', error);
      throw error;
    }
  }

  /**
   * Get list of clinics
   * @returns {Promise<Object>} Clinics data
   */
  static async getClinics() {
    try {
      const { data } = await axiosInstance.get('/visits/clinics');
      return data;
    } catch (error) {
      console.error('Get clinics error:', error);
      throw error;
    }
  }
}

export default AppointmentService;